import React, {Component} from 'react';

/**
 * isResultsChanged()
 * Check if results were updated with new entries
 * @param {array} prevResults
 * @param {array} nextResults
 */
function isResultsChanged(prevResults, nextResults) {
    prevResults = prevResults || [];
    nextResults = nextResults || [];

    if (prevResults.length !== nextResults.length) {
        return true;
    }
    let nextResultsDict = nextResults.reduce((result, nextResultItem) => {
        result[nextResultItem.uuid] = true;
        return result;
    }, {});
    let changedResult = prevResults.find((prevResultsItem) => {
        return !nextResultsDict[prevResultsItem.uuid];
    });
    return !!changedResult;
}

export class AriaStatus extends Component {
    state = {
        bump: false
    };

    componentWillReceiveProps({
        results,
        selectedDestination,
        selectDestinationIndex
    }) {
        // If user has new selected destination
        let newDestination =
            (selectedDestination && selectedDestination.uuid) !==
            (this.props.selectedDestination &&
                this.props.selectedDestination.uuid);
        // If selectDestinationIndex has changed
        let newSelectIndex =
            selectDestinationIndex !== this.props.selectDestinationIndex;
        // Results have changed
        let newResults = isResultsChanged(this.props.results, results);
        // Compute has changed
        let hasChanged = newDestination || newSelectIndex || newResults;
        if (hasChanged) {
            this.setState(({bump}) => ({bump: !bump}));
        }
        return hasChanged;
    }

    render() {
        const {
            results,
            selectDestinationIndex,
            selectedDestination,
            messages
        } = this.props;
        const {bump} = this.state;
        let content = null;
        if (selectDestinationIndex > -1 && results[selectDestinationIndex]) {
            // announce term
            let destinationTerm = results[selectDestinationIndex].term;
            content = destinationTerm;
        } else if (selectedDestination) {
            // announce selected destination
            content = messages.destinationselected.replace(
                '{DESTINATION}',
                selectedDestination.term
            );
        } else if (results) {
            // announce results
            content = messages.resultsfound.replace(
                '{NUM_RESULTS}',
                results.length
            );
        }

        return (
            <div
                className="sr-only"
                aria-atomic="true"
                aria-live="polite"
                role="status"
            >
                {content}
                <span aria-hidden>{bump ? ',' : ',,'}</span>
            </div>
        );
    }
}
